import { Outlet } from "react-router-dom";

const AboutUs = () => {
  return (
    <div>
      <Outlet /> 
    </div>
  );
};

export default AboutUs;
